import { Interjection } from '../../types'

const ёба: Interjection = {
  type: 'interjection',
  interjection: 'ёба',
}

export default ёба
